import React from 'react';
import t from 'tcomb-form';
import _ from 'lodash';

import baseFormFactory from './BaseForm';
import types from './validators/index';

import {ValidatonError} from '../resources/GenericResource';


const Profession = t.struct({
    id: t.maybe(types.positiveInt),
    position: t.maybe(t.Str),
    hourlyRate: t.maybe(types.professionHourlyRate),
    description: t.maybe(t.Str)
});

const CompleteProfileProfessionsFormModel = t.struct({
    professions: t.list(Profession)
});

function professionLayout(locals) {
    const key = `${locals.path[0]}_${locals.path[1]}`;
    const fieldError = locals.error && Object.keys(locals.error).filter(x => x.indexOf(key) > -1).length ? 'Fill in missing field data for this row.' : '';
    const currency = DJ_CONST.LOCALE_CONF.currency;
    const rateError = locals.error && Object.keys(locals.error).filter(x => x.indexOf(`professions||${locals.path[1]}||`) > -1).length ? `Hourly rate needs to be between ${currency}1-${currency}50.` : '';

    let labelClasses = 'form-control form-control-text profession-hourly-rate currency';

    if (currency === '€') {
        labelClasses += ' currency--euro';
    }

    if (rateError) {
        labelClasses += ' has-error';
    }

    return (
        <div className="profession">
            {locals.inputs.id}

            <label className={"form-control form-control-text profession-name " + (fieldError ? "has-error" : "")}>
                <h3 className="label-title">Profession</h3>
                {locals.inputs.position}
                <span className="error-msg">{fieldError}</span>
            </label>

            <label className={labelClasses}>
                <h3 className="label-title">Minimum hourly rate</h3>
                {locals.inputs.hourlyRate}
                <span className="error-msg">{rateError}</span>
            </label>

            <div className="profession-help">{locals.inputs.description.props.value}</div>
        </div>
    );
}

class FormLayout extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {inputs, value} = this.props;
        return (
            <div className="professions-form-content">
                <div className="row row-professions">
                    <div className="form-group">
                        <div className="error-msg">{inputs.professions.error}</div>
                        {inputs.professions}
                    </div>
                </div>
            </div>
        );
    }
}

const Form = baseFormFactory(CompleteProfileProfessionsFormModel, true, true);

class CompleteProfileProfessionsForm extends Form {
    constructor(props) {
        super(props);

        let professions = [{position: "", hourlyRate: "", description: ""}];
        let isValid = false;
        if (typeof props.initialFormData !== 'undefined' && props.initialFormData.length > 0) {
            professions = props.initialFormData;
            isValid = true;
        }

        const options = this.buildPositionOptions(props.positions);

        this.state = {
            value: {professions},
            isValid,
            options,
            disableAdd: professions.length >= props.positions.length
        };
    }

    buildPositionOptions(positions) {
        // [{value: 'x', text: 'y'}, ...]
        return positions.map(pos => {
            return {value: pos.id, text: pos.name};
        });
    }

    cleanProfessions(values) {
        return values.professions.filter((item) => {
            return ((item.position !== '' && item.position !== null) && (item.hourlyRate !== '' && item.hourlyRate !== null && !isNaN(item.hourlyRate)));
        });
    }

    validateMissingProfessionsData(values) {
        const result = {};
        values.professions.forEach((item, index) => {
            const checks = [
                item.position == '' || item.position == null,
                item.hourlyRate == '' || item.hourlyRate == null,
            ];
            if (checks.some(x => x == true) && checks.some(x => x == false)) {
                result[`professions_${index}`] = 'Incomplete data';
            }
        });
        return result;
    }

    getValue() {
        let values = this.refs.form.getValue();
        if (values !== null) {
            values = _.extend({}, values);
            values.professions = this.cleanProfessions(values);

            if (values.professions.length < 1) {
                values = null;
            }
        }

        return values;
    }

    postValidate(state) {
        const value = this.refs.form.getValue();
        if (state.isValid) {
            const missingProfessionsDataErrors = this.validateMissingProfessionsData(value);
            if (!value.professions || value.professions.length === 0 || this.cleanProfessions(value).length === 0) {
                state.isValid = false;
                state.errors = _.merge({}, state.errors, {'professions_generic': 'blabla'});
            }
            if (Object.keys(missingProfessionsDataErrors).length > 0) {
                state.isValid = false;
                state.errors = _.merge({}, state.errors, missingProfessionsDataErrors);
            }
        }
        return state;
    }

    onChange(value, path) {
        const positions = this.props.positions;
        if (path.indexOf('professions') > -1) {
            if (path.indexOf('position') > -1 && value.professions[path[1]]) {
                const changedValue = value.professions[path[1]].position;
                value.professions[path[1]].description = _.result(_.find(positions, 'id', parseInt(changedValue)), 'description');
                value.professions.forEach((profession, index) => {
                    if (path[1] != index && typeof profession !== 'undefined' && profession.position == changedValue) {
                        profession.position = '';
                        profession.description = '';
                    }
                });
            }

            this.setState({disableAdd: value.professions.length >= positions.length});
        }
        super.onChange(value);
    }

    getOptions() {
        const errors = this.props.errors;

        return {
            auto: 'none',
            template: locals => {
                return <FormLayout {...locals}/>;
            },

            fields: {
                professions: {
                    disableOrder: true,
                    disableAdd: this.state.disableAdd,
                    item: {
                        error: errors,
                        template: professionLayout,
                        fields: {
                            id: {
                                type: 'hidden'
                            },
                            position: {
                                options: this.state.options,
                                factory: t.form.Select
                            },
                            description: {
                                type: 'hidden'
                            }
                        }
                    },
                    i18n: {
                        add: '',
                        remove: ''
                    },
                    hasError: !!errors,
                    error: errors && Object.keys(errors).filter(x => x.indexOf('professions_generic') > -1).length ? "Please select a position and an hourly rate." : null

                }
            }
        };
    }

    render() {
        return (
            <div>
                <t.form.Form ref="form" value={this.state.value} type={CompleteProfileProfessionsFormModel}
                             options={this.getOptions()} onChange={this.onChange.bind(this)}/>
            </div>
        );
    }
}

CompleteProfileProfessionsForm.propTypes = {
    initialFormData: React.PropTypes.object.isRequired
};


export default CompleteProfileProfessionsForm;



/** WEBPACK FOOTER **
 ** ./app/src/forms/CompleteProfileProfessionsForm.js
 **/